import { FORM_FIELDS } from '../constants';

export const AUCTION_PAYLOAD_NAMES_TO_REMOVE = [
  'name',
  'auctions',
  'id',
  'demandParameters',
  'supplyParameters',
  'date',
  'returnedAuctions',
  'status',
];

export const USER_PARAMETERS_KEY = 'userParameters';
export const APP_PARAMETERS_KEY = 'appParameters';
export const CONTENT_PARAMETERS_KEY = 'contentParameters';
export const DEMAND_PARAMETERS_KEY = 'demandParameters';

export const WINNING_AUCTIONS = {
  amazon_aps: 'amazon_aps',
  roku: 'roku',
  magnite: 'magnite',
  dv360: 'dv360',
  meli: 'meli',
  tradedesk: 'tradedesk',
  amazon_dsp: 'amazon_dsp',
};

export const INVENTORY_TYPE_MAP = {
  [FORM_FIELDS.INVENTORY_TYPE.name]: 'app',
};

export const FIELD_DISABLED_BY_SUPPLY_SOURCE = {
  [FORM_FIELDS.SESSION_ID.name]: {
    CAS: true,
    DSS: false,
    VDMS: false,
  },
  [FORM_FIELDS.SERIES.name]: {
    CAS: false,
    DSS: true,
    VDMS: true,
  },
  [FORM_FIELDS.ALID_ID.name]: {
    CAS: false,
    DSS: true,
    VDMS: true,
  },
  [FORM_FIELDS.COUNTRY.name]: {
    CAS: false,
    DSS: true,
    VDMS: true,
  },
  [FORM_FIELDS.MAGIC_WORDS_SEARCH.name]: {
    CAS: false,
    DSS: true,
    VDMS: true,
  },
};

export const CAS_BASED_FIELDS = [
  FORM_FIELDS.MAGIC_WORDS_SEARCH.name,
  FORM_FIELDS.ALID_ID.name,
  FORM_FIELDS.SESSION_ID.name,
  FORM_FIELDS.SERIES.name,
];

export const DISNEY_PLUS = 'DisneyPlus';
export const SNAPSHOT_NAME_PREFIX_WARNING = `The auto prefix can not be added because the ${FORM_FIELDS.SNAPSHOT_NAME.label} would be too long.`;
export const UUID_MAX_LENGTH = 36;

export const PARAMETERS_BY_FIELD_NAME = {
  snapshotSearchParametersByAppName: [FORM_FIELDS.APP_NAME.name],
  snapshotSearchParametersByBidState: [FORM_FIELDS.BID_STATE.name],
  snapshotSearchParametersByBrand: [FORM_FIELDS.BRAND.name],
  snapshotSearchParametersByDeviceCategory: [FORM_FIELDS.DEVICE_CATEGORY.name],
  snapshotSearchParametersByChannel: [FORM_FIELDS.CHANNEL.name],
  snapshotSearchParametersByDeviceFamily: [FORM_FIELDS.DEVICE_FAMILY.name],
  snapshotSearchParametersByDistributor: [FORM_FIELDS.DISTRIBUTOR.name],
  snapshotSearchParametersByFormFactor: [FORM_FIELDS.FORM_FACTOR.name],
  snapshotSearchParametersByIfaType: [FORM_FIELDS.IFA_TYPE.name],
  snapshotSearchParametersBySupplySource: [FORM_FIELDS.SUPPLY_SOURCE.name],
  snapshotSearchParametersByVdm: [FORM_FIELDS.VDM.name],
  snapshotSearchParametersByWinningAuction: [FORM_FIELDS.WINNING_AUCTION.name],
  snapshotSearchParametersByCountry: [FORM_FIELDS.COUNTRY.name],
  snapshotSearchParametersByPodPosition: [FORM_FIELDS.POD_POSITION.name],
};

export const PARAMETER_NAMES = {
  [FORM_FIELDS.SUPPLY_SOURCE.name]: [FORM_FIELDS.SUPPLY_SOURCE.name],
  [FORM_FIELDS.APP_NAME.name]: [FORM_FIELDS.APP_NAME.name],
  [FORM_FIELDS.DEVICE_FAMILY.name]: [FORM_FIELDS.DEVICE_FAMILY.name],
  [FORM_FIELDS.IFA_TYPE.name]: [FORM_FIELDS.IFA_TYPE.name],
  [FORM_FIELDS.CHANNEL.name]: [FORM_FIELDS.CHANNEL.name],
  [FORM_FIELDS.VDM.name]: [FORM_FIELDS.VDM.name],
  [FORM_FIELDS.WINNING_AUCTION.name]: [FORM_FIELDS.WINNING_AUCTION.name],
  [FORM_FIELDS.DISTRIBUTOR.name]: [FORM_FIELDS.DISTRIBUTOR.name],
  [FORM_FIELDS.BRAND.name]: [FORM_FIELDS.BRAND.name],
  [FORM_FIELDS.DEVICE_CATEGORY.name]: [FORM_FIELDS.DEVICE_CATEGORY.name],
  [FORM_FIELDS.FORM_FACTOR.name]: [FORM_FIELDS.FORM_FACTOR.name],
  [FORM_FIELDS.COUNTRY.name]: [FORM_FIELDS.COUNTRY.name],
};
